// @flow
import React from 'react'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { imagePath } from 'frontend_core/dist/helpers/image'
import ReservationModel from 'frontend_core/dist/model/Reservation'
import {
  actions as reservationActions,
  type State as reservationState,
} from 'redux/modules/reservation'
import { setUIState, containerIds } from 'redux/modules/ui'
import Path from 'routes/path'
import MainTemplate from 'components/templates/MainTemplate'
import ReservationListPage from 'components/pages/ReservationListPage'
import Colors from 'components/styles/colors'
import { type ReservationType } from 'types/reservation'
import graphql from './graphql'
import { accountLoginUrl } from 'frontend_core/dist/helpers/url'

type PropTypes = {
  reservation: {
    reservations: Array<ReservationType>,
  },
  localUser: {
    id: string,
  },
  ui: {},
  actions: {
    initializeReservations: Function,
    fetchReservations: Function,
    setUIState: Function,
  },
}

class ReservationListPageContainer extends React.Component<PropTypes> {
  static async getInitialProps({ req, res, params, config, isLogin }) {
    if (!isLogin)
      return { redirect: { to: accountLoginUrl(config), status: 302 } }
    return
  }

  constructor(props: PropTypes) {
    super(props)
    this.onReachedBottom = this.onReachedBottom.bind(this)
  }

  componentDidMount() {
    const { actions, localUser } = this.props
    window.scrollTo(0, 0)
    actions.initializeReservations({
      userId: localUser.id,
    })
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { failedFetchReservationsMessage } = this.props.reservation

    if (
      failedFetchReservationsMessage &&
      !prevProps.reservation.failedFetchReservationsMessage
    ) {
      message.warning(failedFetchReservationsMessage)
    }
  }

  onReachedBottom: Function
  onReachedBottom() {
    const { actions, localUser, reservation } = this.props
    const {
      isFetchReservationDetailEnd,
      fetchReservationDetailPage,
      isSuccessFetchReservations,
      failedFetchReservationsMessage,
    } = reservation
    if (!isFetchReservationDetailEnd)
      if (isSuccessFetchReservations && !failedFetchReservationsMessage) {
        actions.fetchReservations({
          userId: localUser.id,
          page: fetchReservationDetailPage,
        })
      }
  }

  render() {
    const { actions, localUser, ui, reservation } = this.props
    const {
      isSuccessFetchReservations,
      failedFetchReservationsMessage,
    } = reservation
    const { fetchReservations } = actions
    const title = i18n.t('server.www.reservations.title')

    const reservationList = reservation.reservations.map(item => {
      const room = item.room || {}
      const owner = item.owner || {}
      const billing = item.billing || {}

      return {
        roomName: room.name || '',
        color: ReservationModel.isActive(item) ? Colors.blue : Colors.grayB,
        thumbnail:
          Array.isArray(room.thumbnails) &&
          room.thumbnails &&
          room.thumbnails[0]
            ? room.thumbnails[0].image
            : imagePath('common/noimage_search.png'),
        ownerName: owner.corp_name || owner.name || '',
        paymentMethodText: billing.payment_method_text || '',
        reservedDateText: item.reserved_date_text || '',
        totalAmount: billing.total_pay_amount_for_user_with_tax_text || '',
        dueDate: item.due_date_for_change_approval,
        topHost: owner.rank,
        profileImage: owner.profile_image,
        notReply: item.message_reader === 'User',
        reservationPhaseTexts: item.phase_text || item.status_text || '',
        unapprovedReservation: item.unapproved_reservation,
        isReadMessage: item.is_read_message,
        id: item.id,
        uid: item.uid,
      }
    })

    return (
      <MainTemplate
        title={title}
        description={i18n.t('server.shared.default_description', { title })}
        hideMustHeader
        {...this.props}
      >
        <ReservationListPage
          isLoading={
            !isSuccessFetchReservations && !failedFetchReservationsMessage
          }
          reservationList={reservationList}
          onReachedBottom={this.onReachedBottom}
        />
      </MainTemplate>
    )
  }
}

function mapStateToProps(state: Object) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...reservationActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(ReservationListPageContainer)),
)



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationListPage/index.jsx